import React from 'react';
import { Icon } from '@wfp/ui';

import { Risk, Seriousness, seriousnessClass, seriousnessColor, seriousnessLabel } from '../../restapi/types';
import { riskIconAsset } from './riskIconAsset';
import { useRiskLabels } from '../../hooks/home';

import './RiskIcon.scss';


interface Props {
	risk: Risk;
	seriousness: Seriousness;
}

const iconSize = '2rem';

export function RiskIcon({seriousness: s, risk: r}: Props) {
	const riskLabel = useRiskLabels();
	const d = `${seriousnessLabel[s]} risk of ${riskLabel[r]}`;
	return (
		<div className={`risk-icon-border ${seriousnessClass[s]}`} title={d}>
			<Icon width={iconSize} height={iconSize}
				  icon={riskIconAsset[r]} description={d}
				  fill={seriousnessColor[s]}/>
		</div>
	);
}
